import { IOrDisclaimerTextProps } from './or-disclaimer-text.types';

export const orDisclaimerTextMockData: IOrDisclaimerTextProps = {
  textSize: 'LG',
  text: 'Disclaimers: Conventional Single Close, Construction-to-Permanent Loan Program.',
};
